var _g, _g2, _circle, _g3, _circle2, _g4, _circle3, _g5, _circle4, _g6, _ellipse, _circle5, _g7, _ellipse2, _g8, _circle6, _g9, _circle7, _g10, _g11, _g12, _circle8, _g13, _circle9, _g14, _circle10, _g15, _circle11, _g16, _circle12, _g17, _circle13, _g18, _circle14, _g19, _circle15, _g20, _circle16, _g21, _circle17, _g22, _circle18, _g23, _circle19, _g24, _circle20, _g25, _circle21, _g26, _circle22, _g27, _ellipse3, _g28, _ellipse4, _ellipse5, _g29, _circle23, _g30, _g31, _circle24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 801,
    height: 547,
    viewBox: "0 0 801 547",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2644_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701 273.5C701 237.427 682.174 202.251 647.142 172.866C612.109 143.481 562.613 121.349 505.538 109.547C448.463 97.7461 386.648 96.8632 328.694 107.021C270.74 117.18 219.528 137.874 182.183 166.225C144.839 194.576 123.219 229.175 120.332 265.206C117.445 301.238 133.434 336.911 166.074 367.262C198.714 397.614 246.383 421.134 302.448 434.552C358.513 447.969 420.187 450.616 478.888 442.124L410.5 273.5H701Z",
    fill: "#76FFD5",
    fillOpacity: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220.258,
    cy: 268.607,
    r: 0.752656,
    transform: "rotate(107.617 220.258 268.607)",
    fill: "#76FFD5"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 220.258,
    cy: 268.607,
    r: 0.752656,
    transform: "rotate(107.617 220.258 268.607)",
    fill: "url(#paint0_radial_2644_229)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 143.215,
    cy: 201.235,
    r: 0.752656,
    transform: "rotate(-98.5946 143.215 201.235)",
    fill: "#76FFD5"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 143.215,
    cy: 201.235,
    r: 0.752656,
    transform: "rotate(-98.5946 143.215 201.235)",
    fill: "url(#paint1_radial_2644_229)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 114.205,
    cy: 167.941,
    r: 0.376328,
    transform: "rotate(-98.5946 114.205 167.941)",
    fill: "#76FFD5"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 114.205,
    cy: 167.941,
    r: 0.376328,
    transform: "rotate(-98.5946 114.205 167.941)",
    fill: "url(#paint2_radial_2644_229)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134.247,
    cy: 184.703,
    r: 0.376328,
    transform: "rotate(-98.5946 134.247 184.703)",
    fill: "#76FFD5"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 134.247,
    cy: 184.703,
    r: 0.376328,
    transform: "rotate(-98.5946 134.247 184.703)",
    fill: "url(#paint3_radial_2644_229)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter5_f_2644_229)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 364.13,
    cy: 401.372,
    rx: 0.5,
    ry: 1,
    transform: "rotate(43.5058 364.13 401.372)",
    fill: "#76FFD5"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 364.13,
    cy: 401.372,
    rx: 0.5,
    ry: 1,
    transform: "rotate(43.5058 364.13 401.372)",
    fill: "url(#paint4_radial_2644_229)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 274.315,
    cy: 307.162,
    r: 0.5,
    transform: "rotate(43.5058 274.315 307.162)",
    fill: "url(#paint5_radial_2644_229)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter6_f_2644_229)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 350.564,
    cy: 423.654,
    rx: 1,
    ry: 0.5,
    transform: "rotate(43.5058 350.564 423.654)",
    fill: "#76FFD5"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 350.564,
    cy: 423.654,
    rx: 1,
    ry: 0.5,
    transform: "rotate(43.5058 350.564 423.654)",
    fill: "url(#paint6_radial_2644_229)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter7_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 332.032,
    cy: 404.685,
    r: 0.5,
    transform: "rotate(43.5058 332.032 404.685)",
    fill: "#76FFD5"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 332.032,
    cy: 404.685,
    r: 0.5,
    transform: "rotate(43.5058 332.032 404.685)",
    fill: "url(#paint7_radial_2644_229)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 345.628,
    cy: 410.697,
    r: 0.5,
    transform: "rotate(43.5058 345.628 410.697)",
    fill: "#76FFD5"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 345.628,
    cy: 410.697,
    r: 0.5,
    transform: "rotate(43.5058 345.628 410.697)",
    fill: "url(#paint8_radial_2644_229)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter9_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 388.131,
    cy: 419.851,
    r: 0.276761,
    transform: "rotate(107.617 388.131 419.851)",
    fill: "#76FFD5"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter10_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225.542,
    cy: 351.56,
    r: 0.138381,
    transform: "rotate(107.617 225.542 351.56)",
    fill: "#76FFD5"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter11_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.083,
    cy: 362.327,
    r: 1.12898,
    transform: "rotate(81.9223 213.083 362.327)",
    fill: "#76FFD5"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 213.083,
    cy: 362.327,
    r: 1.12898,
    transform: "rotate(81.9223 213.083 362.327)",
    fill: "url(#paint9_radial_2644_229)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter12_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 229.677,
    cy: 374.795,
    r: 0.752656,
    transform: "rotate(81.9223 229.677 374.795)",
    fill: "#76FFD5"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 229.677,
    cy: 374.795,
    r: 0.752656,
    transform: "rotate(81.9223 229.677 374.795)",
    fill: "url(#paint10_radial_2644_229)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter13_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 197.841,
    cy: 386.156,
    r: 0.752656,
    transform: "rotate(81.9223 197.841 386.156)",
    fill: "#76FFD5"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 197.841,
    cy: 386.156,
    r: 0.752656,
    transform: "rotate(81.9223 197.841 386.156)",
    fill: "url(#paint11_radial_2644_229)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter14_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 194.572,
    cy: 352.411,
    r: 0.752656,
    transform: "rotate(81.9223 194.572 352.411)",
    fill: "#76FFD5"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 194.572,
    cy: 352.411,
    r: 0.752656,
    transform: "rotate(81.9223 194.572 352.411)",
    fill: "url(#paint12_radial_2644_229)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter15_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 223.28,
    cy: 385.966,
    r: 0.376328,
    transform: "rotate(81.9223 223.28 385.966)",
    fill: "#76FFD5"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 223.28,
    cy: 385.966,
    r: 0.376328,
    transform: "rotate(81.9223 223.28 385.966)",
    fill: "url(#paint13_radial_2644_229)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter16_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 203.391,
    cy: 369.024,
    r: 0.376328,
    transform: "rotate(81.9223 203.391 369.024)",
    fill: "#76FFD5"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 203.391,
    cy: 369.024,
    r: 0.376328,
    transform: "rotate(81.9223 203.391 369.024)",
    fill: "url(#paint14_radial_2644_229)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter17_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127.187,
    cy: 266.208,
    r: 1.12898,
    transform: "rotate(24.1185 127.187 266.208)",
    fill: "#76FFD5"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 127.187,
    cy: 266.208,
    r: 1.12898,
    transform: "rotate(24.1185 127.187 266.208)",
    fill: "url(#paint15_radial_2644_229)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter18_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 142.3,
    cy: 254.029,
    r: 0.752656,
    transform: "rotate(24.1185 142.3 254.029)",
    fill: "#76FFD5"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 142.3,
    cy: 254.029,
    r: 0.752656,
    transform: "rotate(24.1185 142.3 254.029)",
    fill: "url(#paint16_radial_2644_229)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter19_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 139.229,
    cy: 291.803,
    r: 0.752656,
    transform: "rotate(24.1185 139.229 291.803)",
    fill: "#76FFD5"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 139.229,
    cy: 291.803,
    r: 0.752656,
    transform: "rotate(24.1185 139.229 291.803)",
    fill: "url(#paint17_radial_2644_229)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter20_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108.932,
    cy: 276.589,
    r: 0.752656,
    transform: "rotate(24.1185 108.932 276.589)",
    fill: "#76FFD5"
  }))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 108.932,
    cy: 276.589,
    r: 0.752656,
    transform: "rotate(24.1185 108.932 276.589)",
    fill: "url(#paint18_radial_2644_229)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter21_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148.345,
    cy: 265.394,
    r: 0.376328,
    transform: "rotate(24.1185 148.345 265.394)",
    fill: "#76FFD5"
  }))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 148.345,
    cy: 265.394,
    r: 0.376328,
    transform: "rotate(24.1185 148.345 265.394)",
    fill: "url(#paint19_radial_2644_229)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter22_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127.689,
    cy: 277.978,
    r: 0.376328,
    transform: "rotate(24.1185 127.689 277.978)",
    fill: "#76FFD5"
  }))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 127.689,
    cy: 277.978,
    r: 0.376328,
    transform: "rotate(24.1185 127.689 277.978)",
    fill: "url(#paint20_radial_2644_229)"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter23_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 154.297,
    cy: 339.739,
    r: 0.752656,
    transform: "rotate(24.1185 154.297 339.739)",
    fill: "#76FFD5"
  }))), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 154.297,
    cy: 339.739,
    r: 0.752656,
    transform: "rotate(24.1185 154.297 339.739)",
    fill: "url(#paint21_radial_2644_229)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter24_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 296.327,
    cy: 365.602,
    r: 1.12898,
    transform: "rotate(3.98532 296.327 365.602)",
    fill: "#76FFD5"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 296.278,
    cy: 365.615,
    r: 0.666172,
    transform: "rotate(3.98532 296.278 365.615)",
    fill: "url(#paint22_radial_2644_229)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter25_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 278.262,
    cy: 392.69,
    r: 0.376328,
    transform: "rotate(3.98532 278.262 392.69)",
    fill: "#76FFD5"
  }))), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 278.262,
    cy: 392.69,
    r: 0.376328,
    transform: "rotate(3.98532 278.262 392.69)",
    fill: "url(#paint23_radial_2644_229)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter26_f_2644_229)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.808,
    cy: 323.573,
    rx: 0.874466,
    ry: 1.16595,
    transform: "rotate(-60.1254 248.808 323.573)",
    fill: "#76FFD5"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 248.808,
    cy: 323.573,
    rx: 0.874466,
    ry: 1.16595,
    transform: "rotate(-60.1254 248.808 323.573)",
    fill: "url(#paint24_radial_2644_229)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter27_f_2644_229)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.389,
    cy: 317.621,
    rx: 0.582977,
    ry: 0.874466,
    transform: "rotate(-60.1254 271.389 317.621)",
    fill: "#76FFD5"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 271.389,
    cy: 317.621,
    rx: 0.582977,
    ry: 0.874466,
    transform: "rotate(-60.1254 271.389 317.621)",
    fill: "url(#paint25_radial_2644_229)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 267.018,
    cy: 345.127,
    rx: 0.582977,
    ry: 0.874466,
    transform: "rotate(-60.1254 267.018 345.127)",
    fill: "url(#paint26_radial_2644_229)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter28_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 255.826,
    cy: 306.09,
    r: 0.291489,
    transform: "rotate(-60.1254 255.826 306.09)",
    fill: "#76FFD5"
  }))), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 255.826,
    cy: 306.09,
    r: 0.291489,
    transform: "rotate(-60.1254 255.826 306.09)",
    fill: "url(#paint27_radial_2644_229)"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter29_f_2644_229)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.018,
    cy: 345.127,
    rx: 0.582977,
    ry: 0.874466,
    transform: "rotate(-60.1254 267.018 345.127)",
    fill: "#76FFD5"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter30_f_2644_229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 262.215,
    cy: 326.568,
    r: 0.291489,
    transform: "rotate(-60.1254 262.215 326.568)",
    fill: "#76FFD5"
  }))), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 262.215,
    cy: 326.568,
    r: 0.291489,
    transform: "rotate(-60.1254 262.215 326.568)",
    fill: "url(#paint28_radial_2644_229)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2644_229",
    x: 19.9999,
    y: 0,
    width: 781,
    height: 547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2644_229",
    x: 214.505,
    y: 262.854,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2644_229",
    x: 137.463,
    y: 195.482,
    width: 11.5056,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2644_229",
    x: 108.829,
    y: 162.564,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2644_229",
    x: 128.87,
    y: 179.326,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2644_229",
    x: 358.351,
    y: 395.569,
    width: 11.5565,
    height: 11.6055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2644_229",
    x: 344.761,
    y: 417.875,
    width: 11.6061,
    height: 11.5566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2644_229",
    x: 326.532,
    y: 399.186,
    width: 11,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2644_229",
    x: 340.128,
    y: 405.197,
    width: 11,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2644_229",
    x: 382.855,
    y: 414.574,
    width: 10.5537,
    height: 10.5537,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2644_229",
    x: 220.403,
    y: 346.421,
    width: 10.2767,
    height: 10.2773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_2644_229",
    x: 206.954,
    y: 356.198,
    width: 12.2583,
    height: 12.2578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_2644_229",
    x: 223.924,
    y: 369.043,
    width: 11.5055,
    height: 11.5049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2644_229",
    x: 192.088,
    y: 380.403,
    width: 11.5055,
    height: 11.5049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_2644_229",
    x: 188.819,
    y: 346.659,
    width: 11.5055,
    height: 11.5049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_2644_229",
    x: 217.904,
    y: 380.59,
    width: 10.7527,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_2644_229",
    x: 198.015,
    y: 363.647,
    width: 10.7527,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_2644_229",
    x: 121.057,
    y: 260.078,
    width: 12.2585,
    height: 12.2588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_2644_229",
    x: 136.547,
    y: 248.275,
    width: 11.5056,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_2644_229",
    x: 133.477,
    y: 286.05,
    width: 11.5056,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_2644_229",
    x: 103.179,
    y: 270.836,
    width: 11.5056,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_2644_229",
    x: 142.968,
    y: 260.018,
    width: 10.7529,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_2644_229",
    x: 122.313,
    y: 272.602,
    width: 10.7529,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_2644_229",
    x: 148.544,
    y: 333.985,
    width: 11.5056,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_2644_229",
    x: 290.198,
    y: 359.474,
    width: 12.2581,
    height: 12.2578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_2644_229",
    x: 272.886,
    y: 387.313,
    width: 10.7527,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_2644_229",
    x: 242.707,
    y: 317.618,
    width: 12.2023,
    height: 11.9102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_2644_229",
    x: 265.577,
    y: 311.954,
    width: 11.6244,
    height: 11.335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_2644_229",
    x: 250.534,
    y: 300.798,
    width: 10.583,
    height: 10.583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_2644_229",
    x: 261.206,
    y: 339.46,
    width: 11.6244,
    height: 11.335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_2644_229",
    x: 256.924,
    y: 321.276,
    width: 10.583,
    height: 10.583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2644_229"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.258 268.607) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.215 201.235) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.205 167.941) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.247 184.703) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(364.13 401.372) rotate(90) scale(1.33333 0.666667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(274.315 307.162) rotate(90) scale(0.666667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(350.564 423.654) rotate(90) scale(0.666667 1.33333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(332.032 404.685) rotate(90) scale(0.666667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(345.628 410.697) rotate(90) scale(0.666667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.083 362.327) rotate(90) scale(1.50531)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.677 374.795) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.841 386.156) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194.572 352.411) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.28 385.966) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.391 369.024) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.187 266.208) rotate(90) scale(1.50531)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.3 254.029) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.229 291.803) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.932 276.589) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.345 265.394) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.689 277.978) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.297 339.739) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.278 365.615) rotate(90) scale(0.88823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.262 392.69) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248.808 323.573) rotate(90) scale(1.55461 1.16595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(271.389 317.621) rotate(90) scale(1.16595 0.777303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.018 345.127) rotate(90) scale(1.16595 0.777303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.826 306.09) rotate(90) scale(0.388652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2644_229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.215 326.568) rotate(90) scale(0.388652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlow2);
export default __webpack_public_path__ + "static/media/Glow2.cdf41c073e8b19100be3d1d7dd8460b4.svg";
export { ForwardRef as ReactComponent };